//import { useEffect } from "react";

export const useIframe = () => {
  // useEffect(() => {
  if (window.self !== window.top) {
    //Estamos en iframe, pero es test o master?
    if (window.location.href.indexOf("dev.iframe") !== -1) {
      return "iframe-test";
    }
    return "iframe";
  } else {
    //NO estamos en iframe, pero es test o master?
    if (window.location.href.indexOf("dev.iframe") !== -1) {
      return "no-iframe-test";
    }
    return "no-iframe";
  }
  // }, []);
};
